import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CompanyProvider } from './contexts/CompanyContext';
import { ThemeProvider } from './contexts/ThemeContext';
import AppLayout from './components/AppLayout';
import PromptManager from './components/PromptManager';
import AnalysisHistory from './components/AnalysisHistory';
import Insights from './components/Insights';
import UrlInformation from './components/UrlInformation';
import ScheduledJobs from './components/scheduledJobs/ScheduledJobsPage';
import Login from './components/Login';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import UserManagement from './pages/UserManagement';
import AuditPage from './pages/AuditPage';
import QueueAdmin from './pages/QueueAdmin';
import TaxonomyExport from './pages/TaxonomyExport';
import Explore from './pages/Explore';
import Registration from './pages/Registration';
import PasswordReset from './pages/PasswordReset';
import SiteLists from './pages/SiteLists';
import MediaPlanning from './pages/MediaPlanning';
import RelevanceEnginePage from './components/RelevanceEnginePage';
import Clusters from './pages/Clusters';
import GraderPage from './pages/GraderPage';
import JobPerformance from './pages/JobPerformance';
import UiKitShowcase from './pages/UiKitShowcase';


function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <CompanyProvider>
        <Router>
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/register/:token" element={<Registration />} />
          <Route path="/reset-password/:token" element={<PasswordReset />} />
          <Route
            path="/admin/audit"
            element={
              <ProtectedRoute adminOnly>
                <AppLayout>
                  <AuditPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route 
            path="/admin/users" 
            element={
              <ProtectedRoute adminOnly>
                <AppLayout>
                  <UserManagement />
                </AppLayout>
              </ProtectedRoute>
            } 
          />
          <Route
            path="/admin/queue"
            element={
              <ProtectedRoute adminOnly>
                <AppLayout>
                  <QueueAdmin />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/taxonomy"
            element={
              <ProtectedRoute adminOnly>
                <AppLayout>
                  <TaxonomyExport />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/job-performance"
            element={
              <ProtectedRoute adminOnly>
                <AppLayout>
                  <JobPerformance />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/explore"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Explore />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          {/* Main app routes */}
          <Route path="/" element={<Navigate to="/explore" replace />} />
          <Route
            path="/relevance-engine"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <RelevanceEnginePage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/prompts"
            element={
              <ProtectedRoute minRole="user">
                <AppLayout>
                  <PromptManager />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute minRole="eskimi_admin">
                <AppLayout>
                  <AnalysisHistory />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/media-planning"
            element={
              <ProtectedRoute minRole="eskimi_admin">
                <AppLayout>
                  <MediaPlanning />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights"
            element={
              <ProtectedRoute minRole="eskimi_admin">
                <AppLayout>
                  <Insights />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route 
            path="/url-lookup" 
            element={
              <ProtectedRoute adminOnly>
                <AppLayout>
                  <UrlInformation />
                </AppLayout>
              </ProtectedRoute>
            } 
          />
          <Route
            path="/scheduled-jobs"
            element={
              <ProtectedRoute minRole="eskimi_admin">
                <AppLayout>
                  <ScheduledJobs />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/site-lists"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <SiteLists />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/grader"
            element={
              <ProtectedRoute adminOnly>
                <AppLayout>
                  <GraderPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/ui-kit"
            element={
              <ProtectedRoute adminOnly>
                <AppLayout>
                  <UiKitShowcase />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/clusters/*"
            element={
              <ProtectedRoute minRole="eskimi_admin">
                <AppLayout>
                  <Clusters />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          {/* Catch all route - redirect to explore */}
          <Route path="*" element={<Navigate to="/explore" replace />} />
        </Routes>
      </Router>
      </CompanyProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
